export default "__VITE_PUBLIC_ASSET__9d38eea2__"